import { Component, OnInit } from '@angular/core';
import { LoginUnawareComponent } from '../login-unaware-component';
import { GraphClientService } from '../services/graph-client-service';
import { DiagnosticsServiceFactory } from '../services/diagnostics-service-factory';

const MAX_NUMBER_OF_ITEMS = 10;

/**
 * Displays links to downloadable documents sourced from a SharePoint Online document library.
 * The documents can be downloaded using a special anonymous short-lived download URL, which
 * is a part of document metadata returned by Microsoft Graph API query.
 */
@Component({
  selector: 'app-newsletters',
  templateUrl: './newsletters.component.html',
  styleUrls: ['./newsletters.component.scss']
})
export class NewslettersComponent extends LoginUnawareComponent implements OnInit {
  public newsletters: any[];
  public sourceHasMoreItems: boolean;

  constructor(
    diagnosticsFactory: DiagnosticsServiceFactory,
    private graphClient: GraphClientService) {
    super(diagnosticsFactory.create('NewslettersComponent'));
    this.newsletters = [];
  }

  ngOnInit() {
    this.graphClient.getData(this.constructor.name).subscribe(
      data => {
        const dynamicData = data as any;
        const allNewsletters = dynamicData.value as any[];

        if (this.newsletters.length > MAX_NUMBER_OF_ITEMS) {
          this.diagnostics.logWarning(
            `The number of items returned by data service exceeds the ` +
            `max. value of ${MAX_NUMBER_OF_ITEMS} items that can be displayed. ` +
            `The rest of the items are ignored.`);
          this.newsletters = allNewsletters.slice(0, MAX_NUMBER_OF_ITEMS);
          this.sourceHasMoreItems = true;
        } else {
          this.newsletters = allNewsletters;
          this.sourceHasMoreItems = false;
        }
      }, error => {
        this.diagnostics.logError(`Error loading data. Details: ${JSON.stringify(error)}`);
      });
  }

  public downloadFile(item: any) {
    const key = `${this.constructor.name}-downloadFile`;
    const fileName = item.fields.FileLeafRef;

    if (!fileName || fileName.length === 0) {
      this.diagnostics.logError(`Field 'FileLeafRef' must not be empty.`);
      return;
    }

    this.graphClient.getDataWithParameters(key, null, [fileName]).subscribe(
      data => {
        const driveItem = data as any;
        const downloadUrl = driveItem['@microsoft.graph.downloadUrl'];

        if (!downloadUrl) {
          this.diagnostics.logError(`DriveItem resource URL for file ${fileName} is missing.`);
        } else {
          window.location = downloadUrl;
        }
      }, error => {
        this.diagnostics.logError(`Error loading data. Details: ${JSON.stringify(error)}`);
      });
  }
}
